import { Grid } from "@mui/material";
import TimePickerField from "../../../../components/Dashboard/TimePickerField";
import { useIntl } from "../../../../contexts/IntlContext";

type Props = {
  dailyStartTime: string;
  dailyEndTime: string;
  onDailyStartTimeChange: (value: string) => void;
  onDailyEndTimeChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
};

/** Horário diário único (início/fim), repetido em todos os dias do período. */
export default function DailyTimeRangeFields({
  dailyStartTime,
  dailyEndTime,
  onDailyStartTimeChange,
  onDailyEndTimeChange,
  disabled,
  error,
}: Props) {
  const intl = useIntl();
  return (
    <>
      <Grid item xs={12} md={6}>
        <TimePickerField
          label={intl.formatMessage({ id: "liveStreams.period.dailyStartTime" })}
          value={dailyStartTime}
          onChange={onDailyStartTimeChange}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TimePickerField
          label={intl.formatMessage({ id: "liveStreams.period.dailyEndTime" })}
          value={dailyEndTime}
          onChange={onDailyEndTimeChange}
          disabled={disabled}
          error={Boolean(error)}
          helperText={error}
          fullWidth
        />
      </Grid>
    </>
  );
}
